<template>
  <div style="height: 100%">
    <!-- 页面骨架:筛选区(端/类型/人员名称/接口名) + ve-table列表 + 日志详情弹窗 -->
    <div style="display: flex; width: 100%">
      <div style="width: 100%">
        <el-row class="filter-bar" ref="filterBar">
          <el-select size="mini" v-model="formDatas.logPlatform" clearable placeholder="所属端"
            style="width: 150px" @change="partserch">
            <el-option v-for="item in platformOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-select size="mini" v-model="formDatas.logType" clearable placeholder="操作类型"
            style="width: 120px;" @change="partserch">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
          <el-input v-model="formDatas.logUserName" style="width: 140px;" size="mini"
            placeholder="请求人名称" clearable></el-input>
          <el-input v-model="formDatas.logApi" style="width: 180px;" size="mini"
            placeholder="接口名(模糊)" clearable></el-input>
          <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="">搜索</el-button>
          </div>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
        element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
        <div style="width: 100%">
          <ve-table ref="vetable" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            row-key-field-name="logId" style="width: 100%" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[20, 50, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
    </div>

    <!-- 日志详情弹窗:请求方式/地址/参数(全量)/ip/描述;logParams可能超长,pre换行+滚动 -->
    <el-dialog title="操作日志详情" :visible.sync="detailDialog" width="720px">
      <div v-if="detailRow">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="请求时间">{{ detailRow.logTime || "-" }}</el-descriptions-item>
          <el-descriptions-item label="耗时">{{ formatCost(detailRow.logRequestTime) }}</el-descriptions-item>
          <el-descriptions-item label="所属端">
            <el-tag :color="platformTag(detailRow.logPlatform).color" size="mini"
              :style="{ color: '#fff', borderColor: platformTag(detailRow.logPlatform).color }">
              {{ detailRow.logPlatformDes || platformTag(detailRow.logPlatform).text }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="操作类型">
            <el-tag :type="typeTag(detailRow.logType).type" size="mini">
              {{ typeTag(detailRow.logType).text }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="请求人">
            {{ detailRow.logUserName || "-" }}<span v-if="detailRow.logUserId != null"
              style="color: #909399; font-size: 12px">（id:{{ detailRow.logUserId }}）</span>
          </el-descriptions-item>
          <el-descriptions-item label="请求IP">{{ detailRow.logIp || "-" }}</el-descriptions-item>
          <el-descriptions-item label="接口名" :span="2">
            <span class="mono-text">{{ detailRow.logApi || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="请求方式">{{ detailRow.logMethod || "-" }}</el-descriptions-item>
          <el-descriptions-item label="请求地址">
            <span class="mono-text">{{ detailRow.logPath || "-" }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="接口描述" :span="2">{{ detailRow.description || "-" }}</el-descriptions-item>
          <el-descriptions-item label="请求参数" :span="2">
            <pre class="params-pre">{{ detailRow.logParams || "-" }}</pre>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from "qs";
import { getSysLogList } from "../../api/api";
import ClampCell from "../../components/ClampCell.vue";

// 登录端枚举(与后端写日志侧口径一致:0未登录/1pc/2商户端小程序/4供货商后台/5商城用户)
const PLATFORM_OPTIONS = [
  { value: 1, label: "PC端" },
  { value: 2, label: "商户端小程序" },
  { value: 4, label: "供货商后台" },
  { value: 5, label: "商城用户" },
  { value: 0, label: "未登录" },
];
// 操作类型枚举(1查询/2新增/3编辑/4删除;0及未知兜底显示为其他)
const TYPE_OPTIONS = [
  { value: 1, label: "查询" },
  { value: 2, label: "新增" },
  { value: 3, label: "编辑" },
  { value: 4, label: "删除" },
];
// 耗时告警阈值(ms):超过显示红色
const SLOW_REQUEST_MS = 1000;

export default {
  name: "SystemLog",
  components: { ClampCell },
  data() {
    return {
      tableLoading: false,
      totalCount: 0,
      tableHight: 520,
      tableData: [],
      formDatas: {
        logPlatform: "",
        logType: "",
        logUserName: "",
        logApi: "",
        currentPage: 1,
        pageSize: 20,
      },
      platformOptions: PLATFORM_OPTIONS,
      typeOptions: TYPE_OPTIONS,
      // 详情弹窗
      detailDialog: false,
      detailRow: null,
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "logPlatform",
          key: "logPlatform",
          title: "所属端",
          width: 100,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            const tag = this.platformTag(row.logPlatform);
            // 未登录灰/pc蓝/商户青/供货商橙/商城紫
            return h("el-tag", {
              props: { size: "mini" },
              style: { backgroundColor: tag.color, borderColor: tag.color, color: "#fff" },
            }, row.logPlatformDes || tag.text);
          },
        },
        {
          field: "logType",
          key: "logType",
          title: "类型",
          width: 70,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            const tag = this.typeTag(row.logType);
            // 查询绿/新增蓝/编辑橙/删除红
            return h("el-tag", { props: { type: tag.type, size: "mini" } }, tag.text);
          },
        },
        {
          field: "logApi",
          key: "logApi",
          title: "接口名",
          width: 240,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 等宽字体逐字符可读；超4行截断，截断时 hover 预览
            return h("div", { style: { fontFamily: "'Courier New', Consolas, monospace", fontSize: "12px" } }, [
              h(ClampCell, { props: { text: row.logApi || "-" } }),
            ]);
          },
        },
        {
          field: "logPath",
          key: "logPath",
          title: "接口地址",
          width: 240,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h("div", { style: { fontFamily: "'Courier New', Consolas, monospace", fontSize: "12px" } }, [
              h(ClampCell, { props: { text: row.logPath || "-" } }),
            ]);
          },
        },
        {
          field: "description",
          key: "description",
          title: "接口具体类型",
          width: 140,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            return h(ClampCell, { props: { text: row.description || "-" } });
          },
        },
        {
          field: "logIp",
          key: "logIp",
          title: "ip地址",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }) => row.logIp || "-",
        },
        {
          field: "logParams",
          key: "logParams",
          title: "携带参数",
          width: 350,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 参数最长：4行截断省略号，截断时 hover 预览全部；完整结构化查看走「详情」弹窗
            return h("div", { style: { fontFamily: "'Courier New', Consolas, monospace", fontSize: "12px" } }, [
              h(ClampCell, { props: { text: row.logParams || "-" } }),
            ]);
          },
        },
        {
          field: "logUserName",
          key: "logUserName",
          title: "操作人员",
          width: 130,
          align: "center",
          renderBodyCell: ({ row }, h) => {
            // 名称为主,id小字辅助(各端id独立自增,排查时需带id)
            return h("div", [
              h("div", row.logUserName || "-"),
              row.logUserId != null && row.logUserId !== 0
                ? h("div", { style: { color: "#909399", fontSize: "12px" } }, "id:" + row.logUserId)
                : null,
            ]);
          },
        },
        {
          field: "logTime",
          key: "logTime",
          title: "操作时间",
          width: 160,
          align: "center",
        },
        {
          field: "operation",
          key: "operation",
          title: "操作",
          width: 70,
          align: "center",
          fixed: "right",
          renderBodyCell: ({ row }, h) => {
            return h("el-button", {
              props: { type: "text", size: "mini" },
              style: { color: "#409EFF", padding: "0" },
              on: { click: () => this.openDetail(row) },
            }, "详情");
          },
        },
      ],
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight;
    this.tableHight = calcTableHeight(this, this.windheight, 140);
    this.getList();
  },
  methods: {
    // 端tag映射(自定义色:pc蓝/商户青/供货商橙/商城紫/未登录灰)
    platformTag(logPlatform) {
      const map = {
        0: { text: "未登录", color: "#909399" },
        1: { text: "PC端", color: "#409EFF" },
        2: { text: "商户端小程序", color: "#13c2c2" },
        4: { text: "供货商后台", color: "#f89c2a" },
        5: { text: "商城用户", color: "#9254de" },
      };
      return map[logPlatform] || { text: "未知", color: "#909399" };
    },
    // 类型tag映射(查询绿/新增蓝/编辑橙/删除红/其他灰)
    typeTag(logType) {
      const map = {
        1: { text: "查询", type: "success" },
        2: { text: "新增", type: "" },
        3: { text: "编辑", type: "warning" },
        4: { text: "删除", type: "danger" },
      };
      return map[logType] || { text: "其他", type: "info" };
    },
    // 耗时展示(详情弹窗用)
    formatCost(ms) {
      return ms == null ? "-" : ms + "ms" + (ms > SLOW_REQUEST_MS ? "（慢）" : "");
    },
    getList() {
      this.tableLoading = true;
      // 注意:getSysLogList的api封装内未做qs.stringify,此处先序列化再传
      getSysLogList(qs.stringify(this.formDatas)).then((res) => {
        this.tableLoading = false;
        if (!res) {
          return;
        }
        this.tableData = res.data || [];
        this.totalCount = res.total || 0;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.getList();
    },
    pageNumberChange(pageIndex) {
      this.formDatas.currentPage = pageIndex;
      this.getList();
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.getList();
    },
    // 打开详情弹窗(全量字段格式化展示,含超长logParams)
    openDetail(row) {
      this.detailRow = row;
      this.detailDialog = true;
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.ve-table-container {
  height: auto !important;
}
</style>

<style scoped>
/* 接口名/地址等宽字体 */
.mono-text {
  font-family: "Courier New", Consolas, monospace;
  word-break: break-all;
}

/* 请求参数全量展示:保留换行,超高滚动 */
.params-pre {
  margin: 0;
  max-height: 260px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-break: break-all;
  font-family: "Courier New", Consolas, monospace;
  font-size: 12px;
  line-height: 1.6;
  background: #f5f7fa;
  padding: 8px;
  border-radius: 4px;
}
</style>